import { Link, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { armadoEntregado, getDocumentsId } from '../../redux/actions/actionDocument';
import { ARMADO, ENTREGADO } from '../../Constantes/constantesFiltros';
import { format } from 'date-fns';

export default function DocumentsCard({id, addressEvent, dateReception, dateSend, numberDocument, name_client, state, armado, entregado, parcial }){
       
    const dispatch = useDispatch();
      
        
    //let tilde = localStorage.getItem(id) === id ? !armado : armado
    //console.log(tilde)

    // const handleArmado = (e) => {
    //     const {checked} = e.target
    //     const {name} = e.target
    //     const {value} = e.target
    //     console.log(checked)
    //     console.log(id)
    //     console.log(value)
    //     //setArmado(!armado)
    //     //if(typeof id === "string"){console.log("ID es STRING")} else {console.log("ID no es string")}
    //     //if(typeof value === "string"){console.log("value es STRING")} else {console.log("Value no es string")}
    //     setArmado(!armado)
    //     if(checked === true){
    //         console.log("checkeado")
    //         localStorage.setItem(id, value)
    //     }
    //     if(checked === false){
            
    //         console.log("descheckeado")
    //         localStorage.removeItem(id)
    //     }        
    // }
    
    const handleArmado = (e) => {
        //console.log(e.target.value)
        const { value } = e.target
        console.log(value)
        if(value === ARMADO && armado === false && entregado === false){
            console.log("true")            
            dispatch(armadoEntregado({
                id:id,
                armadoAux: true,
                entregadoAux: false
            }))
            setTimeout(()=> {
                window.location.reload();  
            }, 500)
            
        } else if(value === ARMADO && armado === true && entregado === false) {
            console.log("false")            
            dispatch(armadoEntregado({
                id:id,
                armadoAux: false,
                entregadoAux: false
            }))
            setTimeout(()=> {
                window.location.reload();  
            }, 500)            
        }
        
        if(value === ENTREGADO && armado === true && entregado === false){
            console.log("entregado true")            
            dispatch(armadoEntregado({
                id:id,
                armadoAux: true,
                entregadoAux: true
            }))
            setTimeout(()=> {
                window.location.reload();  
            }, 500)   
        } else if(value === ENTREGADO && armado === true && entregado === true){
            console.log("entregado false")            
            dispatch(armadoEntregado({
                id:id,
                armadoAux: true,
                entregadoAux: false
            }))
            setTimeout(()=> {
                window.location.reload();  
            }, 500) 
        }
        
    }
    

    // const handleDispatch = async () => {
        
    //     dispatch(armadoEntregado(pedidoArmado))
    // }

    //console.log(pedidoArmado)

    return(
        <div className="flex flex-row">            
            <div className={armado === false && entregado === false ?  "flex flex-row  bg-slate-300 hover:text-slate-400" 
                : (armado === true && entregado === false ? "flex flex-row bg-green-600 hover:text-slate-400" : (armado === true && entregado === true) ? "flex flex-row bg-red-600 hover:text-slate-400" : null) }>
            {/* <div className="flex flex-row  bg-slate-300 hover:text-slate-400"> "flex flex-row bg-green-600 hover:text-slate-400"*/}
            <Link to={`/documentos/${id}`}>
            <div className='flex flex-row'>
                <div className='border-b-2 border-white w-12'>                    
                    <p className="text-[11px] font-bold text-center">{numberDocument}</p>
                </div>
                <div className='border-b-2 border-white pl-2 w-60'>                    
                    <p className="text-[11px] font-bold text-left pl-2">{name_client}</p>
                </div>
                <div className='border-b-2 border-white pl-2 w-80'>                    
                    <p className="text-[11px] font-bold text-left pl-2">{addressEvent}</p>
                </div>
                <div className='border-b-2 border-white w-20'>                    
                    <p className="text-[11px] font-bold text-center">{dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}</p>
                </div>
                <div className='border-b-2 border-white w-20'>                    
                    <p className="text-[11px] font-bold text-center">{dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}</p>
                </div>
                <div className='border-b-2 border-white w-20'>
                    {parcial === true ? <p className="text-[11px] font-bold text-left pl-2">Parcial</p> : (state === true ? <p className="text-[11px] font-bold text-left pl-2">Saldado</p> : <p className="text-[11px] font-bold text-left pl-2">No saldado</p>)}
                </div>
                </div>
            </Link>                              
            </div>                
                <div className="flex flex-row text-[8pt] border-b-2 border-white">
                     {/* <input 
                        className='border-b-2 border-white'
                        type="checkbox" 
                        id={id}                       
                        checked={tilde}
                        value={id}
                        onChange={handleArmado}    
                    />                     */}
                    <div className="bg-green-700 w-14 text-center hover:bg-green-400">
                        <button className="text-black font-bold hover:text-white" value={ARMADO} onClick={handleArmado}>
                            Armado
                        </button>
                    </div>
                    <div className="bg-red-700 w-14 text-center hover:bg-red-400">
                        <button className="text-black font-bold hover:text-white" value={ENTREGADO} onClick={handleArmado}>
                            Entregado
                        </button>
                    </div>
                </div> 
        </div>
    )
}